import FqApi from '@/services/fq-api'

export default {
  async getTagsByCategory(category) {
    const url = `/tags/getTagsByCategory/${category}`
    const result = await FqApi.get(url)
    return result.data
  },
  postTags(entityTags) {
    return FqApi.post('/tags/postTags', entityTags)
  },
  updateAssetTags(assetId, entityTags) {
    return FqApi.post(`/tags/updateAssetTags/${assetId}`, entityTags)
  }
}
